import { dark } from "@mui/material/styles/createPalette";
import { EducationView } from "./EducationView";

export const EducationPage = ({darkMode}) => {
  return <EducationView darkMode={darkMode}/>;
};
